<template>
  <div>
    <Header />
    <div class="content">
      <h2>Soon...</h2>
    </div>
    <div class="image-container">
      <div class="brew-image">
        <img class="image-2" src="../assets/bs1.jpg" alt="" />
      </div>
    </div>
    <div class="image-container">
      <div class="brew-image">
        <img class="image-2" src="../assets/bs2.jpg" alt="" />
      </div>
    </div>
    <modal v-if="showThisModal" @close="hideModal()"></modal>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import modal from "@/components/Modal.vue";

export default {
  components: {
    Header,
    modal
  },
  data() {
    return {
      showThisModal: false
    };
  },
  methods: {
    showModal() {
      this.showThisModal = true;
    },
    hideModal() {
      this.showThisModal = false;
    }
  }
};
</script>
